import React from "react"
import { BarraSoluciones } from "../../../BarraSoluciones"
import { SolucionesHeaders } from "../../SolucionesHeaders"
import { MobiliarioImg } from "../../../CarouselImages/MobiliarioImg"
import { CarouselSection } from "../../../CarouselSection"
import "./info.scss"
import "./landing.scss"
import "./carousel.scss"
import { Link } from "gatsby"

export const LandingSection = ({ classTitle, mainTitle }) => {
  return (
    <>
      <div className={`info-${classTitle}-container`}>
        <SolucionesHeaders
          titleSolucion={mainTitle.toUpperCase()}
          cNameSolucion={classTitle}
        />
        <div
          className={`${classTitle}-subtitle-container`}
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <h3>
            En <span className="subtitle-skol-solutions">Skol Solutions </span>
            ofrecemos soluciones de mobiliario profesional específico para
            videoconferencia, con accesorios que permiten simplificar el manejo
            de los cables al usuario final y al mismo tiempo evitar a los
            encargados de IT el tener que estar lidiando con el daño en los
            cableados.
          </h3>
        </div>

        <CarouselSection
          classTitle={classTitle}
          images={MobiliarioImg}
          s1920="530px"
          s1366="415px"
          s1024="362px"
          s768="256px"
          s640="256px"
          s360="218px"
        />

        <div
          className={`${classTitle}-button-container`}
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <Link className="soluciones-btn" to="/contacto">
            <button className={`${classTitle}-btn-cotizar`}>COTIZAR</button>
          </Link>
        </div>
      </div>
      <BarraSoluciones />
    </>
  )
}
